import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useHomeCta = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    const scrollToCta = () =>
      document.querySelector("#cta")?.scrollIntoView({ behavior: "smooth" });

    if (location.pathname !== "/") {
      navigate("/");
      window.setTimeout(scrollToCta, 250);
    } else {
      scrollToCta();
    }
  }, [location.pathname, navigate]);
};
